export default {
  overview: {
    title: "Projekt Übersicht",
    archive_title: "Archivierte Projekte",
    subtitle: "Auflistung aller Projekte.",
    actions: {
      create_new: "Neues Projekt erstellen",
    },
    search: {
      placeholder: "bspw. Name, etc.",
    },
    table: {
      // Die aufgeklappte Zeile (Rechtsklick oder Pfeil). `counts` sind Singular | Plural, die Zahl
      // steht fett davor; jede führt in das gleichnamige Register des Projekts.
      expanded: {
        address: "Adresse",
        site: "Baustelle",
        no_address: "Keine Adresse hinterlegt",
        leading_users: "Leitung",
        no_leading_users: "Keine Leitung zugewiesen",
        phases: "Phasen",
        no_phases: "Keine Phasen angelegt",
        phase_current: "läuft",
        created: "Erstellt am {date}",
        open: "Projekt öffnen",
        counts_failed: "Die Anzahlen konnten nicht geladen werden.",
        retry: "Erneut versuchen",
        contents: "Im Projekt",
        counts: {
          constructionReports: "[[cr]] | [[cr.pl]]",
          hourlyWageReports: "[[hwr]] | [[hwr.pl]]",
          machines: "Maschine | Maschinen",
          materials: "Material | Materialien",
          additionalEfforts: "Zusätzliche Leistung | Zusätzliche Leistungen",
        },
      },
      headers: {
        alternative_id: "Kennung",
        name: "Name",
        place: "Ort",
        montage_start_date: "Projektbeginn",
        montage_end_date: "Geplantes Projektende",
        montage_period: "Projektzeitraum",
        leading_users: "Leitung",
        budget: "Budget",
        createdAt: "Erstellt am",
      },
      empty: {
        place: "Nicht gesetzt",
        montage_period: "Kein Zeitraum",
        budget: "Kein Budget",
      },
    },
  },
  // Leistungskatalog: das mit dem Kunden im Angebot vereinbarte Leistungsverzeichnis (Titel und
  // Positionen), gebucht aus den Bautagesberichten.
  serviceCatalog: {
    loading: "Lade Leistungskatalog…",
    no_matches: "Keine Position passt zu diesem Filter.",
    add_title: "Titel",
    add_title_long: "Titel anlegen",
    add_position: "Position",
    add_position_below: "Position darunter anlegen",
    add_row: "Position oder Titel hinzufügen",
    add_subtitle: "Untertitel anlegen",
    missing: "Fehlt noch: {fields}",
    goes_under: "Kommt unter {title}",
    goes_top: "Kommt auf die oberste Ebene",
    discard: "Verwerfen",
    // How the question before leaving the page names a new row still open (an opened one is named by its
    // Pos-Nr. and Kurztext).
    unsaved_new_row: "Neue Zeile im Leistungskatalog",
    discard_title: "Eingaben verwerfen?",
    discard_text: "Die offene Zeile ist noch nicht gespeichert. Ihre Eingaben darin gehen verloren.",
    statement_print: "Leistungsstand drucken…",
    statement_dialog: {
      title: "Leistungsstand drucken",
      subtitle: "PDF mit Mengen und Fortschritt je Position.",
      mode_total: "Gesamtstand",
      mode_period: "Zeitraum",
      total_hint: "Alles, was bis zum Stichtag erbracht wurde.",
      period_hint:
        "Was im Zeitraum hinzukam, aus Buchungen und Leistungsständen, dazu der Gesamtstand am Ende des Zeitraums. Passt zur Abschlagsrechnung.",
      cutoff: "Stichtag",
      from: "Von",
      to: "Bis",
      with_prices: "Mit Preisen",
      download: "PDF herunterladen",
      range_invalid: "Das Startdatum liegt nach dem Enddatum.",
      error: "Der Leistungsstand konnte nicht erstellt werden.",
    },
    completion: "Fertigstellung",
    positions: "Positionen",
    positions_done: "{done} von {total} fertig",
    quantity_total: "Menge",
    contract_value: "Auftragswert",
    source_manual: "manuell",
    earned_value: "Leistungswert",
    open_value: "Offener Rest",
    excess: "Mehrmengen",
    excess_count: "{count} Mehrmenge | {count} Mehrmengen",
    search: "Pos-Nr., Kurz- oder Langtext suchen",
    state: "Stand",
    origin: "Herkunft",
    phase: "Bauabschnitt",
    no_phase: "Ohne Bauabschnitt",
    all: "Alle",
    filter: "Filter",
    filter_reset: "Filter zurücksetzen",
    main_contract: "Hauptauftrag",
    oz: "Pos-Nr.",
    kind: "Art",
    short_text: "Kurztext",
    long_text: "Langtext",
    less: "Weniger",
    quantity: "Menge",
    unit: "Einheit",
    unit_price: "EP",
    total: "Gesamt",
    actual: "Ist",
    actual_of_planned: "Ist / Soll",
    progress: "Fortschritt",
    remaining: "Rest {amount}",
    type: "Positionsart",
    parent: "Übergeordneter Titel",
    top_level: "Oberste Ebene",
    order: "Reihenfolge",
    note: "Notiz",
    toggle: "Auf- oder zuklappen",
    move_up: "Nach oben",
    move_down: "Nach unten",
    move_to: "Verschieben nach…",
    move_title: "Verschieben",
    delete_title: "{oz} löschen?",
    delete_text: "Der Eintrag wird aus dem Leistungskatalog entfernt.",
    delete_title_cascade:
      "Der Titel und alle Titel und Positionen darunter werden gelöscht. Gebuchte Positionen können nicht gelöscht werden.",
    save_error: "Eintrag konnte nicht gespeichert werden.",
    position_taken: "Diese Pos-Nr. ist im Leistungskatalog bereits vergeben.",
    quantity_invalid: "Gültige Menge (≥ 0) eingeben.",
    unit_price_invalid: "Gültigen Einzelpreis (≥ 0) eingeben.",
    unit_price_too_large: "Dieser Einzelpreis ist zu groß.",
    quantity_too_large: "Diese Menge ist zu groß.",
    import_hint:
      "Zeilen werden über die Pos-Nr. zugeordnet, in der Reihenfolge der Datei. Ohne „Übergeordnete Pos-Nr.“ wird der Titel aus der Nummer abgeleitet (2.1.12 → 2.1). Gebuchte Mengen bleiben unverändert.",
    kinds: {
      TITLE: "Titel",
      POSITION: "Position",
    },
    types: {
      NORMAL: "Normalposition",
      OPTIONAL: "Bedarfsposition",
      ALTERNATIVE: "Wahlposition",
    },
    type_hints: {
      NORMAL: "Zählt zum Auftragswert.",
      OPTIONAL:
        "Nur bei Bedarf ausgeführt. Zählt nicht zum Auftragswert, Ausgeführtes wird trotzdem als Leistung gezählt.",
      ALTERNATIVE:
        "Alternative zu einer anderen Position. Sie ist weder buchbar noch im Auftragswert enthalten. Bei Beauftragung auf Normalposition stellen.",
    },
    states: {
      OPEN: "Offen",
      IN_PROGRESS: "In Arbeit",
      DONE: "Fertig",
      EXCESS: "Mehrmenge",
    },
    // Nur noch für Protokolleinträge aus der Zeit vor den Leistungsständen (eine übernommene Menge je Position).
    adopted: {
      quantity: "Übernommene Menge",
      date: "Stand vom",
    },
    bookings: {
      report: "BTB {nr}",
      allocated_cost: "Zugeordnete Kosten",
    },
    // Leistungsstand je Stichtag: die Gesamtmenge einer Position bis einschließlich eines Tages.
    stands: {
      record: "Leistungsstand erfassen",
      heading: "Leistungsstand zum",
      hint: "Gesamtmenge je Position bis einschließlich Stichtag. Buchungen bis zu diesem Tag sind darin enthalten.",
      date: "Stichtag",
      planned: "Soll",
      before: "Bisher",
      stand: "Stand",
      stand_on: "Stand zum {date}",
      opening: "Anfangsstand",
      from_stand: "Stand {date}",
      booked_since: "+ {amount} gebucht",
      booked_only: "gebucht",
      below: "unter bisher {amount}",
      removed: "wird entfernt",
      needs_delete: "Zum Entfernen eines Leistungsstands fehlt die Berechtigung.",
      invalid: "Keine gültige Menge",
      too_large: "Diese Menge ist zu groß",
      date_invalid: "Bitte einen Stichtag eingeben.",
      problem_hidden: "Ungültige Eingabe außerhalb der Suche: {positions}",
      save: "Speichern ({count})",
      saved: "{count} Leistungsstand zum {date} gespeichert | {count} Leistungsstände zum {date} gespeichert",
      save_error: "Die Leistungsstände konnten nicht gespeichert werden.",
      load_error: "Die Positionen konnten nicht geladen werden.",
      empty: "Keine Position, für die ein Leistungsstand erfasst werden kann.",
      discard_title: "Eingaben verwerfen?",
      discard_text: "Die Leistungsstände zum {date} sind noch nicht gespeichert.",
      unsaved: "Leistungsstand zum {date}",
      excess: "Mehrmenge",
    },
    history: {
      title: "Verlauf",
      actual: "Ist {actual} von {planned}",
      stand: "Leistungsstand",
      opening: "Anfangsstand (ohne Datum)",
      delta: "{amount} gegenüber vorher",
      covered: "im Stand vom {date} enthalten",
      add: "Leistungsstand hinzufügen",
      empty: "Noch keine Leistungsstände oder Buchungen.",
      delete_title: "Leistungsstand vom {date} löschen?",
      delete_opening_title: "Anfangsstand löschen?",
      delete_text: "Das Ist der Position ergibt sich danach wieder aus dem Stand davor und den Buchungen.",
      save_error: "Der Leistungsstand konnte nicht gespeichert werden.",
      load_error: "Der Verlauf konnte nicht geladen werden.",
    },
    // Beschriftungen für Protokolleinträge aus der Zeit der Montage-Stückliste.
    legacy_montage: {
      profile: "Profil",
      unit_weight: "Einzelgewicht",
      mounted_quantity: "Davon montiert",
      status: "Status",
      status_date: "Statusdatum",
      status_labels: {
        PLANNED: "Geplant",
        DELIVERED: "Geliefert",
        MOUNTED: "Montiert",
        ACCEPTED: "Abgenommen",
      },
    },
    gaeb: {
      button: "GAEB",
      title: "GAEB importieren",
      hint: "Leistungsverzeichnis aus der Kalkulations- oder AVA-Software übernehmen (GAEB DA XML: X83, X84 oder X86). Sie sehen erst, was sich ändert.",
      file: "GAEB-Datei",
      drop: "GAEB-Datei hierher ziehen oder auswählen",
      new: "{count} neu",
      changed: "{count} geändert",
      unchanged: "{count} unverändert",
      only_in_catalog: "{count} nur im Katalog",
      warnings: "{count} Hinweise",
      booked: "gebucht",
      mode: "Übernahme",
      into_change_order: "Positionen zuordnen",
      import: "Importieren",
      error: "Die Datei konnte nicht gelesen werden.",
      modes: {
        MERGE_BY_OZ: "Ergänzen und aktualisieren",
        REPLACE_IF_UNBOOKED: "Ersetzen (gebuchte Positionen bleiben)",
      },
      states: {
        NEW: "Neu",
        CHANGED: "Geändert",
        UNCHANGED: "Unverändert",
        ONLY_IN_CATALOG: "Nur im Katalog",
      },
    },
    change_orders: {
      title: "Nachträge",
      single: "Nachtrag",
      add: "Nachtrag",
      hint: "Leistungen außerhalb des Angebots. Nur beauftragte Nachträge zählen zum Auftragswert; Positionen ordnen Sie im Positionsdialog einem Nachtrag zu.",
      edit: "Nachtrag bearbeiten",
      create: "Nachtrag anlegen",
      delete_text: "Der Nachtrag wird aus dem Leistungskatalog entfernt.",
      empty: "Noch keine Nachträge.",
      number: "Nr.",
      name: "Bezeichnung",
      state: "Status",
      submitted_at: "Eingereicht am",
      decided_at: "Entschieden am",
      amount_claimed: "Angebotene Summe",
      delete_blocked: "Nachtrag hat noch Positionen",
      status: {
        REQUESTED: "Beantragt",
        APPROVED: "Beauftragt",
        REJECTED: "Abgelehnt",
      },
    },
  },

  create: {
    title: "Projekt Anlegen",
    subtitle: "Neues Projekt anlegen.",
  },
  detail: {
    title: "Projekt Details",
    loading: "Projekt wird geladen",
    // Zählt Einträge, deren Preis die Stundenlohn-Abrechnung später nicht berechnen kann.
    price_gap: {
      tooltip: "Einträge ohne gepflegten Preis. Abrechnung nicht möglich, solange sie offen sind.",
    },
    // When the project never opened at all. "denied" covers both "not yours" and "gone", because
    // the backend answers the two alike.
    blocked: {
      denied: {
        title: "Kein Zugriff auf dieses Projekt",
        text: "Dieses Projekt ist Ihnen nicht zugeordnet oder existiert nicht mehr. Wenden Sie sich an die Bauleitung, wenn Sie hier arbeiten sollen.",
      },
      error: {
        title: "Projekt konnte nicht geladen werden",
        text: "Die Verbindung zum Server ist fehlgeschlagen. Versuchen Sie es erneut.",
      },
      retry: "Erneut versuchen",
      overview: "Zur Projektübersicht",
    },
    hints: {
      no_project_id: "Projekt muss erstmal erstellt werden",
      no_customer: "Weisen sie vorerst dem Projekt einen Kunden zu.",
    },
    tabs: {
      general: "Allgemein",
      contacts: "Ansprechpartner",
      additional_efforts: "Zusätzliche Leistungen",
      materials: "Materialien",
      machines: "Maschinen",
      categories: "Kategorien",
      users: "Personal",
      files: "Dateiablage",
      userPositions: "Personalrollen",
      hourlyWageReports: "[[hwr.pl]]",
      constructionReports: "[[cr.pl]]",
      serviceCatalog: "Leistungskatalog",
      // Nicht "Zeiterfassung": der Reiter zeigt, was auf dieses Projekt gebucht wurde, nicht das Modul.
      timetracking: "Zeiten",
      phases: "Phasen",
      configuration: "Konfiguration",
      activity: "Protokoll",
    },
    actions: {
      actions: "Aktionen",
      planning: {
        create: "Personalplanung erstellen",
        open: "In Personalplanung öffnen",
      },
      invoice: "[[hwi]] starten",
      customer: "Kunde öffnen",
      update: "Speichern",
      duplicate: {
        duplicate: "Duplizieren",
        modal: {
          title: "Projekt duplizieren",
          name: "Name",
          alternativeId: "Kennung",
          agree: "Duplizieren",
          required: "Dieses Feld ist erforderlich",
        },
      },
      // Archiviert (docs/archiving.md): weg aus allen Listen und gesperrt für neue Arbeit, aber les-, druck- und abrechenbar.
      archive: {
        // „Entfernen“: ein Projekt, auf dem schon etwas erfasst wurde, kommt ins Archiv, sonst wird es gelöscht.
        text: "Das Projekt verschwindet aus allen Übersichten und Auswahllisten. Wurde darauf schon etwas erfasst, kommt es ins Archiv: Bestehende Berichte bleiben lesbar, korrigierbar, druckbar und abrechenbar, neue Berichte, Zeiten oder Planungen entstehen darauf nicht mehr. Du kannst es jederzeit reaktivieren. Sonst wird es gelöscht.",
        hint: "Keine neuen Berichte, Zeiten oder Planungen. Bestehendes bleibt bearbeitbar und abrechenbar.",
      },
    },
    form: {
      customer: {
        add_customer: "Kunde",
        customer_locked: "Der Kunde kann nach der Erstellung nicht mehr geändert werden.",
        no_data:
          "Geben Sie <kbd>enter</kbd> ein um einen neuen Kunden zu erstellen mit dem Unternehmens Namen <strong>{value}</strong>",
        create: {
          title: "Erstelle Kunden",
          subtitle: "Erstelle einen neuen Kunden",
          form: {
            company: "Unternehmen",
          },
        },
        contact: {
          active_subheader: "Alle Projekt Ansprechpartner",
          inactive_subheader: "Alle Inaktiven Ansprechpartner",
          filter: "Ansprechpartner filtern",
          no_project_contacts: "Keine Projekt Ansprechpartner zugewiesen",
          add_contact: "Neuen Ansprechpartner hinzufügen",
          edit: "Bearbeiten",
          activate: "Hinzufügen",
          deactivate: "Entfernen",
          position: {
            no_results_matching: "Keine Ergebnissen gefunden zu <strong>{value}</strong>",
            positions: "Ansprechpartner Positionen",
          },
          email: "Email",
          email_unset: "Nicht vorhanden",
          first_name: "Vorname",
          last_name: "Nachname",
          telephone_number: "Telefonnummer",
          telephone_number_unset: "Nicht vorhanden",
          mobile_telephone_number: "Mobile Telefonnummer",
          mobile_telephone_number_unset: "Nicht vorhanden",
          gender: "Geschlecht",
        },
      },
      general: {
        sections: {
          base_data: "Stammdaten",
          customer: "Kunde",
          address: "Standort",
          note: "Notiz",
        },
        name: "Name",
        alternative_id: "Kennung",
        alternative_id_locked: "Die Kennung kann nach der Erstellung nicht mehr geändert werden.",
        montage_start_date: "Projektbeginn",
        montage_end_date: "Geplantes Projekt Ende",
        lat: "Lat",
        lng: "Lng",
        note: "Notizen",
        // Über der Karte, solange das Projekt keine Koordinaten hat. Die Adresse kann trotzdem
        // vollständig sein, daher ist nur von der Nadel die Rede, nicht vom Standort.
        no_map_pin: "Nicht auf der Karte markiert",
        // Darunter, solange die Karte Klicks annimmt (Adressfelder offen).
        set_map_pin_hint: "Klicken Sie in die Karte, um die Nadel zu setzen.",
        // Die Adressfelder selbst stehen unter `general.address.*` — sie sind in jeder
        // Maske dieselben. Hier bleibt nur, was den Projekt-Standort ausmacht.
        address_search_unavailable_hint:
          "Tragen Sie die Adresse in die Felder unten ein und klicken Sie auf die Karte, um die Position zu setzen.",
      },
      pricing: {
        selling_price: "Verkaufspreis",
        surcharge: "Aufschlag",
      },
      remove_confirm: {
        title: "Entfernen bestätigen",
        text: "Möchten Sie „{name}“ wirklich aus dem Projekt entfernen?",
        agree: "Entfernen",
      },
      // Einkaufspreise, die das Projekt pro Maschine / Material führt (Kopie der Stammdaten beim Hinzufügen).
      purchase_price_variants: {
        title: "Einkaufspreise in diesem Projekt",
        variants_count: "{count} Preis | {count} Preise",
        // Unter einem Preis, den die Stammdaten anders führen; danach folgt deren Preis. Namen und Preise nicht
        // als Parameter: escapeParameter machte aus „C25/30“ „C25&#x2F;30“.
        master_price: "Stammdaten:",
        // Unter den Preisen, für einen Preis der Stammdaten, den das Projekt nicht hat. Davor steht sein Name,
        // danach sein Preis.
        master_only: "nur in den Stammdaten:",
        // Unter einem Preis, solange Buchungen zu einem anderen Preis festgeschrieben sind als dem im Feld;
        // danach folgt „Umstellen“. Umgestellt wird beim Speichern des Projekts.
        reprice: {
          stay: "{count} Buchung bleibt bei {prices} | {count} Buchungen bleiben bei {prices}",
          stay_no_price: "{count} Buchung bleibt ohne Preis | {count} Buchungen bleiben ohne Preis",
          // Hinter „… bleiben bei 45,00 EUR“, wenn auch Buchungen ohne Preis darunter sind.
          or_no_price: "oder ohne Preis",
          switch: "Umstellen",
          switching:
            "{count} Buchung wird beim Speichern auf {price} umgestellt | {count} Buchungen werden beim Speichern auf {price} umgestellt",
          keep: "Nicht umstellen",
        },
      },
      // Strikter Arbeitsbereich: die Einkaufspreise des Projekts sind die der Lieferanten, mit Objektpreisen
      // (docs/suppliers.md, „Objektpreise“). Preise und Namen setzt die Komponente selbst dahinter.
      supplier_prices: {
        no_price: "kein Preis in {currency}",
      },
      machines: {
        empty_customer: "Weisen sie vorerst dem Projekt einen Kunden zu.",
        delete: "Löschen",
        add_machine: "Maschine hinzufügen",
        filter: "Maschinen filtern",
        empty: "Keine Maschinen zugewiesen",
        add_machine_packet_title: "Paket",
        add_machine_packet_text: "{index} von {length}",
        skip_machine_packet_item: "Nicht Übernehmen",
        no_data: "Keine Maschinen gefunden",
        name: "Name",
        purchase_price: "Einkaufspreis",
        selling_price: "Verkaufspreis",
        selling_price_text: "Maschinen Verkaufspreis",
        customer_selling_price: "Kunden Verkaufspreis",
        project_selling_price: "Projekt Verkaufspreis",
        not_set: "Nicht gesetzt",
        dialog_title: "Maschine hinzufügen",
        device_number: "Gerätenummer",
        device_number_add: "Nummer eingeben, Enter zum Hinzufügen",
        selling_price_customer_takeover: "Verkaufspreis wird für den Kunden mit übernommen.",
        customer_origin: "Bereits beim Kunden hinterlegt",
      },
      materials: {
        empty_customer: "Weisen sie vorerst dem Projekt einen Kunden zu.",
        delete: "Löschen",
        add_material: "Material hinzufügen",
        filter: "Materialien filtern",
        empty: "Keine Materialien zugewiesen",
        packet: "Paket",
        no_data: "Keine Materialien gefunden",
        name: "Name",
        purchase_price: "Einkaufspreis",
        selling_price: "Verkaufspreis",
        selling_price_text: "Material Verkaufspreis",
        customer_selling_price: "Kunden Verkaufspreis",
        project_selling_price: "Projekt Verkaufspreis",
        not_set: "Nicht gesetzt",
        dialog_title: "Material hinzufügen",
        selling_price_customer_takeover: "Verkaufspreis wird für den Kunden mit übernommen.",
        customer_origin: "Bereits beim Kunden hinterlegt",
      },
      additional_efforts: {
        empty_customer: "Weisen sie vorerst dem Projekt einen Kunden zu.",
        delete: "Löschen",
        add_additional_effort: "Zusätzliche Leistung hinzufügen",
        filter: "Zusätzliche Leistungen filtern",
        empty: "Keine Zusätzlichen Leistungen zugewiesen",
        packet: "Paket",
        no_data: "Keine Zusätzlichen Aufwände gefunden",
        name: "Name",
        purchase_price: "Realpreis",
        selling_price: "Verkaufspreis",
        selling_price_text: "Zusätzliche Leistungs Verkaufspreis",
        customer_selling_price: "Kunden Verkaufspreis",
        project_selling_price: "Projekt Verkaufspreis",
        not_set: "Nicht gesetzt",
        dialog_title: "Zusätzliche Leistung hinzufügen",
        selling_price_customer_takeover: "Verkaufspreis wird für den Kunden mit übernommen.",
        customer_origin: "Bereits beim Kunden hinterlegt",
      },
      users: {
        add_user: "Personal hinzufügen",
        selected_count: "{count} ausgewählt",
        filter: "Personal filtern",
        empty: "Kein Personal zugewiesen",
        no_data: "Kein Personal gefunden",
        delete_user: "Löschen",
        leading_user: "Personal mit leitender Fähigket",
        leading_tag: "Leitend",
        name: "Name",
        email: "Email",
        created_at: "Erstellt am",
        position: {
          text: "Personalrollen",
          positions: "Positionen",
          no_results_matching: "Keine Ergebnissen gefunden zu <strong>{value}</strong>.",
        },
        no_email_set: "-Keine E-Mail-",
      },
      userpositions: {
        no_data: "Keine Personalrollen gefunden",
        add_userposition: "Personalrolle hinzufügen",
        selected_count: "{count} ausgewählt",
        filter: "Personalrollen filtern",
        empty: "Keine Personalrollen zugewiesen",
        delete: "Löschen",
        hourlyRate: "Stundensatz",
        hourlyRateText: "Personalrollen Stundensatz",
        no_customer: "Zuerst muss der Kunden erstellt werden",
        remove_confirm_held:
          "Möchten Sie „{name}“ wirklich aus dem Projekt entfernen? Eine Person im Personal hat diese Rolle und verliert sie damit. | Möchten Sie „{name}“ wirklich aus dem Projekt entfernen? {count} Personen im Personal haben diese Rolle und verlieren sie damit.",
      },
      // Druckstatus als Text, geteilt von Bautagesberichten und Stundenlohnarbeiten. Die Tabelle
      // kommt mit einem blossen Häkchen aus, weil die Spaltenüberschrift darüber steht — die
      // Karten-Ansicht hat keine, also benennt das Kennzeichen dort seinen Zustand selbst.
      print_state: {
        printed: "Gedruckt",
        unprinted: "Nicht gedruckt",
      },
      // Day markers of the report calendars on the hourly wage report and construction report tabs.
      reportCalendar: {
        clear: "Zurücksetzen",
        // Klappt den Kalender auf Tablet und Handy auf, wo er über der Liste steht.
        toggle: "Kalender",
        legend: {
          printed: "Gedruckt",
          unprinted: "Nicht gedruckt",
          missing: "Fehlender Bericht",
        },
      },
      hourlyWageReports: {
        // Nennt den Bericht, wie "+ Position" im Leistungskatalog: ein blosses "Erstellen" auf beiden
        // Berichts-Reitern hat Bautagesberichte angelegt, wo ein Stundenlohnbericht gemeint war, und
        // umgekehrt.
        create: "[[hwr]]",
        delete: "Löschen",
        empty: "Keine [[hwr.pl]] vorhanden",
        delete_modal: {
          title: "[[hwr]] löschen?",
          text: "[[hwr]] {nr} wird endgültig gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
          agree: "Löschen",
          disagree: "Abbrechen",
        },
        move_title: "[[hwr.pl]] verschieben",
        print: "Drucken",
        search: {
          search: "Suche",
          startDateFrom: "Ausführungsdatum von",
          startDateTo: "Ausführungsdatum bis",
        },
        actions: {
          print: "Drucken",
          open: "Öffnen",
          delete: "Löschen",
        },
        headers: {
          projectNr: "Nr",
          categories: "Kategorien",
          startDate: "Ausführungsdatum",
          createdBy: "Ersteller",
          printed: "Gedruckt",
        },
        no_project_id: "Projekt muss erstmal erstellt werden",
        expand: {
          description: "Beschreibung",
          no_description: "Keine Beschreibung",
          createdAt: "Erstellt am",
          history: "Verlauf",
          index: "Index",
          costing: "Nachkalkulation",
          attached: "[[cr:Im/In der/Im]] [[cr]] enthalten",
          separate: "Separat gezählt",
        },
      },
      // Duplizieren und Verschieben, auf beiden Berichts-Reitern: in der Leiste über einer Auswahl und
      // im Menü jeder Zeile.
      reportTransfer: {
        duplicate: "Duplizieren",
        move: "Verschieben",
        target: "Projekt",
      },
      constructionReport: {
        no_project_id: "Projekt muss erstmal erstellt werden",
        search: "Suche",
        dateFrom: "Datum von",
        dateTo: "Datum bis",
        // Siehe `hourlyWageReports.create`.
        create: "[[cr]]",
        empty: "Keine [[cr.pl]] vorhanden",
        // Ein Projekt hat einen [[cr]] pro Tag: Eine Kopie braucht deshalb ihren eigenen Tag.
        duplicate_title: "[[cr.pl]] duplizieren",
        duplicate_subtitle: "Jede Kopie braucht einen Tag ohne [[cr]].",
        duplicate_date: "Kopie am",
        // Unter dem Tag einer Kopie, wenn das Wetter dieses Tages nicht geladen werden konnte: Die Kopie
        // trägt dann das Wetter des Originals, {date} ist dessen Tag.
        weather_kept: "Wetter vom {date} übernommen",
        move_title: "[[cr.pl]] verschieben",
        move_taken: "{project} hat am {date} schon [[cr:einen/eine/ein]] [[cr]].",
        delete_modal: {
          title: "[[cr]] löschen?",
          text: "[[cr]] {nr} wird endgültig gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
          agree: "Löschen",
          disagree: "Abbrechen",
        },
        expand: {
          service_entries: "Gebuchte Leistungen",
          services: "Freie Leistungen",
          history: "Verlauf",
          index: "Index",
          no_details: "Keine Details vorhanden",
        },
        actions: {
          print: "Drucken",
          open: "Öffnen",
          delete: "Löschen",
        },
        headers: {
          projectNr: "Nr",
          date: "Datum",
          services: "Tagesleistungen",
          createdBy: "Ersteller",
        },
      },
      configuration: {
        default_currency: "Währung",
        currency_change_note: "Kann nur verändert werden, wenn das Projekt keine [[cr.pl]] und [[hwr.pl]] gepflegt hat",
        // Mit Lieferanten sperren auch Mieten die Währung.
        currency_change_note_rentals:
          "Kann nur verändert werden, wenn das Projekt keine [[cr.pl]], [[hwr.pl]] und Mieten hat",
        work_days: "Standardarbeitstage",
        hide_hourly_wage_report_user_names: "Namen des Personals auf [[hwr.datpl]] ausblenden",
        hide_hourly_wage_report_user_names_change_note:
          "Ändern dieses Wertes führt dazu, dass alle bisherigen gedruckten [[hwr.pl]] einen neuen Index bekommen",
        attach_hourly_wage_reports_to_construction_reports: "[[hwr.pl]] [[cr:zum/zur/zum]] [[cr]] anhängen",
        attach_hourly_wage_reports_to_construction_reports_hint:
          "Die Kosten sind dann [[cr:im/in der/im]] [[cr]] enthalten und werden in der Nachkalkulation nicht separat gezählt. Solange das Projekt noch [[cr:keinen/keine/kein]] [[cr]] hat, zählen sie separat. Gilt für alle [[hwr.pl]] ohne eigene Auswahl.",
        pdf_templates: "PDF-Vorlagen",
        pdf_templates_hint:
          "Mit welcher Vorlage dieses Projekt seine Dokumente druckt. Ohne Auswahl gilt die Standard-Vorlage. Eine Änderung gilt für künftige Drucke.",
        pdf_template_default: "Standard: {name}",
        pdf_template_missing: "Gelöschte Vorlage",
        options: "Optionen",
      },
      phases: {
        title: "Projekt Phasen",
        period: "Projektzeitraum",
        days: "Tage",
        no_dates: "Ohne Datum",
        name: "Phasenname",
        start_date: "Start Datum",
        start_short: "Start",
        end_date: "End Datum",
        end_short: "Ende",
        save: "Speichern",
        cancel: "Abbrechen",
        add: "Phase Hinzufügen",
        empty_list: 'Noch keine Phasen vorhanden. Klicke "Phase Hinzufügen" um loszulegen.',
        average_capacity: "Durchschnittskapazität",
        average_capacity_label: "Durchschnittskapazität:",
        average_capacity_help:
          "Benötigte Mitarbeiter pro Arbeitstag der Phase. Gilt für jeden Tag, für den keine eigene Kapazität hinterlegt ist.",
        custom_capacities: "Benutzerdefinierte Kapazitäten",
        from_date: "Von Datum",
        to_date: "Bis Datum",
        capacity: "Kapazität",
        add_capacity: "Hinzufügen",
        override_warning: "Dies wird bestehende Kapazitäten überschreiben:",
        validation: {
          required: "{field} ist erforderlich",
          min_date: "{field} kann nicht vor {date} liegen",
          max_date: "{field} kann nicht nach {date} liegen",
          date_order: "Das Startdatum muss vor dem Enddatum liegen",
          name_required: "Phasenname ist erforderlich",
        },
      },
    },
  },
  costs: {
    title: "Mitlaufende Nachkalkulation",
    subtitle: "Projektkosten über die Zeit und Abweichung vom Budget.",
    action: "Mitlaufende Nachkalkulation",
    header: {
      projects: "Projekte",
      range: "Zeitraum",
      range_from: "Von",
      range_to: "Bis",
      view_mode: "Ansicht",
      mode_heatmap: "Heatmap",
      mode_chart: "Verlauf",
      mode_week: "KW",
      mode_analysis: "Analyse",
      mode_services: "Leistungen",
      valuation_cost: "Kosten",
      valuation_selling: "Erlös",
      no_projects_selected: "Wählen Sie ein oder mehrere Projekte aus",
      projects_count: "{selected} von {total} Projekten ausgewählt",
      // Solange die Gesamtzahl noch nicht vom Server kam: nur zählen, keine Gesamtzahl behaupten.
      projects_count_selected: "{selected} ausgewählt",
      select_all: "Alle auswählen",
      clear_all: "Auswahl löschen",
    },
    presets: {
      days_30: "30 T",
      days_90: "90 T",
      ytd: "YTD",
      month: "Monat",
    },
    budget: {
      title: "Budget",
      title_help:
        "Eine Kostenobergrenze für dieses Projekt: der Betrag, den Sie insgesamt maximal ausgeben möchten. Die App vergleicht den verbrauchten Anteil mit dem Fertigstellungsgrad des Projekts. Wer früh viel ausgibt und danach monatelang still steht, bleibt im Plan, solange der Fortschritt mithält.",
      amount: "Budgetbetrag",
      amount_help:
        "Der Betrag, den Sie für dieses Projekt maximal ausgeben möchten (Kosten, nicht Erlös). Leer lassen für keine Obergrenze.",
      amount_positive: "Betrag größer als 0 eingeben oder leer lassen, um das Budget zu entfernen.",
      amount_too_large: "Dieser Budgetbetrag ist zu groß.",
      status_help:
        "Budgetverbrauch im Vergleich zum Fertigstellungsgrad: Achtung, wenn der Verbrauch mehr als {threshold} Prozentpunkte vorausläuft, kritisch ab {critical} Punkten, überzogen über 100 %. Ohne Fertigstellungsgrad nur als Obergrenze: Achtung ab {cap} %, kritisch ab 100 % Verbrauch.",
      completion: "Fertigstellungsgrad (%)",
      completion_help:
        "Wie viel des Projekts erledigt ist. Hat das Projekt einen Leistungskatalog, zählt dessen Fertigstellung; sonst tragen Sie den Wert hier von Hand ein und halten ihn aktuell.",
      completion_placeholder: "Nicht erfasst",
      completion_invalid: "Ganze Zahl von 0 bis 100 eingeben oder leer lassen.",
      completion_from_catalog: "Aus dem Leistungskatalog. Ändert sich mit jeder Buchung [[cr:im/in der/im]] [[cr]].",
      completion_updated: "Zuletzt aktualisiert am {date}",
      completion_stale: "Zuletzt aktualisiert am {date}, bitte prüfen",
      completion_line: "Fertigstellung: {percent} % ({source})",
      completion_not_set: "Kein Fertigstellungsgrad erfasst, nur Obergrenze",
      health_tooltip: "{used} % Budget verbraucht bei {completion} % Fertigstellung ({source})",
      health_tooltip_no_completion: "{used} % Budget verbraucht, kein Fertigstellungsgrad erfasst",
      source: {
        SERVICE_CATALOG: "Leistungskatalog",
        MANUAL: "manuell",
        NONE: "nicht erfasst",
        MIXED: "gemischt",
      },
      not_set: "Kein Budget gesetzt",
      set_budget: "Budget setzen",
      edit: "Budget bearbeiten",
      reset: "Zurücksetzen",
    },
    plan: {
      title: "Nachkalkulation",
      title_help:
        "Ist dieses Projekt noch profitabel? Geben Sie den mit dem Kunden vereinbarten Preis und Ihren Zielgewinn ein. Die App zeigt Ihnen dann laufend Ihre Marge, sobald Kosten gebucht werden. Sie müssen nicht bis zum Projektende warten.",
      contract_value: "Auftragswert",
      contract_from_catalog:
        "Aus dem Leistungskatalog (Hauptauftrag plus beauftragte Nachträge). Der von Hand eingetragene Wert bleibt als Rückfallwert gespeichert.",
      source_catalog: "Leistungskatalog",
      contract_value_help:
        "Der mit dem Kunden vereinbarte Nettopreis (ohne Umsatzsteuer), also das Geld, das Sie für diesen Auftrag erwarten. Ihr Gewinn ist in diesem Preis bereits enthalten; der Gewinnzuschlag wird nicht zusätzlich aufgeschlagen.",
      contract_positive: "Betrag größer als 0 eingeben oder leer lassen, um ihn zu entfernen.",
      contract_too_large: "Dieser Auftragswert ist zu groß.",
      profit_surcharge: "Gewinnzuschlag",
      profit_surcharge_help:
        "Der angestrebte Gewinn als Prozentsatz auf Ihre Kosten (z. B. 10 %). Er steckt bereits im Auftragswert und wird daraus herausgerechnet: So entstehen die Sollkosten, die höchstens anfallen dürfen.",
      margin_basis_help:
        "Marge = erwarteter Gewinn ÷ Auftragswert, also bezogen auf den Umsatz. Der Gewinnzuschlag rechnet dagegen auf die Kosten. Deshalb sind die beiden Prozentzahlen nie gleich: 10 % Zuschlag entsprechen 9,1 % Marge.",
      profit_short: "Gewinn",
      profit_positive: "0 oder mehr eingeben.",
      profit_too_large: "Dieser Gewinnzuschlag ist zu groß.",
      target_cost: "Sollkosten",
      target_cost_help:
        "Die höchsten Kosten, die dieser Auftrag verursachen darf, um den Zielgewinn noch zu erreichen (Auftragswert ÷ (1 + Gewinn %)). Bleiben Sie darunter, sind Sie im Plan.",
      cost_to_date: "Bisherige Kosten",
      cost_to_date_help:
        "Alles, was bisher auf dieses Projekt gebucht wurde (Stunden, Maschinen und Material), über die gesamte Laufzeit und nicht nur im gewählten Zeitraum.",
      projected_profit: "Erwarteter Gewinn",
      projected_profit_help:
        "Auftragswert minus bisherige Kosten: Ihr Gewinn, wenn nichts mehr ausgegeben würde. Grün bedeutet Gewinn, Rot bedeutet, der Auftrag läuft mit Verlust.",
      margin_trend_help:
        "Veränderung der erwarteten Marge in den letzten 30 Tagen (in Prozentpunkten). Ein fallender Pfeil zeigt einen Kostendrift: die Marge sinkt.",
      preview: "Ergebnisvorschau",
      preview_help: "So sehen die Werte nach dem Speichern aus, exakt vom Server neu berechnet.",
      not_set: "Kein Auftragswert gesetzt",
      set_plan: "Kalkulation setzen",
      edit: "Kalkulation bearbeiten",
      reset: "Zurücksetzen",
    },
    employer_contribution: {
      incl: "inkl. Arbeitgeberanteil {amount}",
      column_help: "Die Lohnkosten enthalten den Arbeitgeberanteil und liegen deshalb über Stunden × Satz.",
      range_note: "Die Personalkosten sind Vollkosten und enthalten {amount} Arbeitgeberanteil im gewählten Zeitraum.",
      help: "Auf die Personalkosten wird der Arbeitgeberanteil zur Sozialversicherung aufgeschlagen (Standardsatz in den Einstellungen, je Mitarbeiter überschreibbar). Erlöse werden nicht aufgeschlagen, der Anteil senkt also die Marge.",
    },
    analysis: {
      cost_structure: "Kostenstruktur",
      revenue_structure: "Erlösstruktur",
      project_ranking: "Projekt-Rentabilität",
      project_ranking_hint: "Projekte nach erwarteter Marge, von am rentabelsten bis am unrentabelsten.",
      report_ranking: "Kostenintensivste Berichte",
      report_ranking_revenue: "Ertragsstärkste Berichte",
      report: "Bericht",
      date: "Datum",
      cost: "Kosten",
      revenue: "Erlös",
      kind_hwr: "SL",
      kind_cr: "BT",
      no_data: "Keine Daten im gewählten Zeitraum.",
      no_overlays: "Blende eine Berichts-Überlagerung ([[hwr.pl]] / [[cr.pl]]) ein, um die Zahlen zu sehen.",
    },
    manual: {
      title: "Manuelle Kosten & Einnahmen",
      subtitle:
        "Zusätzliche Posten, die nicht aus Berichten stammen. Kosten fließen in die Ausgaben, Einnahmen erhöhen den erwarteten Gewinn.",
      add: "Hinzufügen",
      add_title: "Posten hinzufügen",
      edit_title: "Posten bearbeiten",
      empty: "Noch keine manuellen Posten erfasst.",
      date: "Datum",
      type: "Art",
      category: "Kategorie",
      description: "Beschreibung",
      amount: "Betrag",
      direction: {
        COST: "Kosten",
        REVENUE: "Einnahme",
      },
      cancel: "Abbrechen",
      save: "Speichern",
      save_error: "Posten konnte nicht gespeichert werden.",
      amount_positive: "Betrag größer als 0 eingeben.",
      amount_too_large: "Dieser Betrag ist zu groß.",
    },
    // Mieten (docs/suppliers.md): Teil der Maschinenkosten. Bearbeitet am Projekt (Maschinen).
    rentals: {
      title: "Mieten",
      subtitle: "In den Maschinenkosten enthalten.",
      open: "Zu den Maschinen",
      device: "Gerät",
      period: "Zeitraum",
      cost: "Kosten",
      rent: "Miete",
      kinds: {
        RENT: "Miete",
        // Zubehör der Miete, an seinem Tag: „Zubehör · Tieflöffel 60 cm · Mietpark Nord“
        ACCESSORY: "Zubehör",
        DELIVERY: "Anlieferung",
        PICKUP: "Abholung",
      },
    },
    // Eine Berichtsbuchung eines gemieteten Geräts an einem Miettag: die Miete trägt die Kosten.
    in_rental: "in Miete enthalten",
    services: {
      title: "Leistungskatalog",
      subtitle: "Fertigstellung, Auftragswert und Leistungswert gegenüber den bisherigen Kosten.",
      completion: "Fertigstellung",
      positions: "{done} von {total} Positionen fertig",
      excess: "{count} mit Mehrmenge",
      contract_value: "Auftragswert",
      source_manual: "manuell",
      earned_value: "Leistungswert",
      spent_to_date: "Bisherige Kosten",
      earned_vs_spent: "Leistung minus Kosten",
      earned_vs_spent_help:
        "Positiv bedeutet: die Baustelle hat mehr erbracht als sie gekostet hat. Negativ bedeutet: sie arbeitet ihrem Geld voraus.",
      requested_change_orders: "Beantragte Nachträge",
      earned_without_contract: "Leistung ohne Auftrag",
      open_tab: "Zum Leistungskatalog",
      analysis_title: "Nachkalkulation je Leistung",
      analysis_subtitle:
        "Je Position: vereinbart, erbracht, gekostet. Die Kosten [[cr:jedes/jeder/jedes]] [[cr.gen]] werden auf die dort gebuchten Positionen verteilt.",
      cutoff: "Stichtag",
      sort_tree: "Gliederung",
      sort_margin: "Verlustbringer zuerst",
      empty: "Kein Leistungskatalog vorhanden.",
      col_contract: "Auftrag",
      col_earned: "Leistungswert",
      col_target_cost: "Soll-Kosten",
      col_cost: "Ist-Kosten",
      col_margin: "Deckungsbeitrag",
      col_margin_percent: "DB %",
      total: "Summe",
      allocated: "Zugeordnete Kosten",
      unallocated: "Nicht zugeordnet",
      unallocated_help:
        "Kosten, die keiner Position zugeordnet sind: [[hwr.pl]], manuelle Kosten und [[cr.pl]] ohne gebuchte Leistung.",
      stand_chip: "Stand",
      stand_help: "{amount} aus dem Leistungsstand vom {date}, ohne Kosten aus [[cr.datpl]]",
      stand_help_opening: "{amount} aus dem Anfangsstand, ohne Kosten aus [[cr.datpl]]",
      uncosted: "Leistungswert ohne Berichtskosten",
      uncosted_help:
        "Leistungswert, den nur ein Leistungsstand belegt. Ihm sind keine Kosten zugeordnet, der Deckungsbeitrag dieser Positionen fällt dadurch zu hoch aus.",
    },
    defaults: {
      load_recent: "Zuletzt besuchte Projekte laden",
      select_all: "Alle Projekte auswählen",
      empty_title: "Wähle Projekte aus",
      empty_subtitle: "Wähle ein oder mehrere Projekte aus, oder lade deine zuletzt besuchten Projekte.",
    },
    status: {
      on_track: "Im Plan",
      warning: "Achtung",
      critical: "Kritisch",
      over: "Überzogen",
      unknown: "Kein Budget",
    },
    streams: {
      hourly: "Personal",
      machine: "Maschinen",
      material: "Material",
      effort: "Sonstige",
      total: "Gesamt",
      selling_total: "Erlös",
    },
    week_table: {
      week: "Kalenderwoche",
      week_prefix: "KW",
    },
    combined: {
      all_projects: "Alle Projekte",
      selected_projects: "Ausgewählte Projekte ({count})",
    },
    health: {
      revenue: "Erlös",
      margin: "Marge",
      percent_of_budget: "{percent}% des Budgets",
      percent_of_budget_vs_completion: "{percent}% des Budgets bei {completion}% Fertigstellung",
      no_budgets: "Keine Budgets gesetzt. Budget je Projekt festlegen, um den Fortschritt zu verfolgen.",
      projects_budgeted: "{budgeted} von {total} mit Budget",
      contract_value: "Auftragswert",
      projected_profit: "Erwarteter Gewinn",
      plan_help:
        "Werte über das gesamte Projekt, unabhängig vom gewählten Zeitraum: gesamter Auftragswert gegenüber den bisher gebuchten Gesamtkosten und der erwartete Gewinn, wenn nichts mehr ausgegeben wird. (Erlös/Marge oben gelten nur für den gewählten Zeitraum.)",
      no_plans: "Keine Kalkulation gesetzt. Auftragswert je Projekt setzen, um die Marge zu verfolgen.",
      projects_planned: "{planned} von {total} mit Kalkulation",
      mixed_currency: "Projekte mit unterschiedlichen Währungen. Summen können ungenau sein.",
    },
    legend: {
      actual: "Ist",
      today: "Heute",
      less: "Weniger",
      more: "Mehr",
      intensity: "Pro Projekt, logarithmisch",
      contained: "Nur [[cr:im/in der/im]] [[cr]] enthaltene Berichte",
    },
    expand: "Verlauf anzeigen",
    collapse: "Verlauf schließen",
    open_project: "Projekt öffnen",
    rate_notice:
      "Maschinen und Materialien zum Einkaufspreis, der beim Speichern des Berichts festgeschrieben wurde; Stundensätze wie aktuell hinterlegt. Werte können von tatsächlichen Abrechnungen abweichen.",
    no_reports: "Keine Berichte im gewählten Zeitraum.",
    loading: "Lade Kostendaten…",
    load_error: "Kostendaten konnten nicht geladen werden.",
    invalid_range: "Ungültiger Zeitraum: Das Startdatum liegt nach dem Enddatum.",
    chart_aria: "Kumulierte Kostenkurve",
    construction_reports: {
      toggle: "[[cr.pl]] anzeigen",
      title: "[[cr.pl]]",
      entry: "[[cr]]",
    },
    hourly_wage_reports: {
      toggle: "[[hwr.pl]] anzeigen",
      title: "[[hwr.pl]]",
      entry: "[[hwr]]",
      contained: "im BTB {number}",
      contained_unlinked: "im BTB",
      contained_hint:
        "[[cr:Im/In der/Im]] [[cr]] enthalten und dort bereits gezählt, daher hier nicht noch einmal addiert.",
      // The hover on a dashed heatmap cell, where every report of the day is contained. Inside the
      // popover the rows carry their own marks and `contained_hint` explains them on hover, so
      // nothing is written across the list.
      contained_cell_hint: "[[cr:Im/In der/Im]] [[cr]] enthalten, nicht doppelt gezählt",
      // A day that also has cost of its own: only part of it is carried by the Bautagesbericht, and
      // the shading is the rest.
      contained_cell_hint_partial:
        "Enthält auch [[hwr.pl]], die [[cr:im/in der/im]] [[cr]] enthalten sind und nicht doppelt gezählt werden",
    },
    construction_report_costs: {
      action: "Kostenaufstellung",
      title: "Kostenaufstellung [[cr]]",
      title_selling: "Erlösaufstellung [[cr]]",
      back: "Zurück",
      print: "Drucken",
      open_report: "[[cr]] öffnen",
      loading: "Lade Kosten…",
      load_error: "Kosten konnten nicht geladen werden.",
      print_error: "PDF konnte nicht erstellt werden.",
      report_number: "Bericht-Nr.",
      date: "Datum",
      customer: "Auftraggeber",
      project: "Bauvorhaben",
      shift: "Schicht",
      duration: "Dauer",
      break: "Pause",
      work_time: "Arbeitszeit",
      labor: "Lohnkosten",
      labor_selling: "Lohnerlös",
      incl_employer_contribution: "inkl. Arbeitgeberanteil {amount}",
      machines: "Gerätekosten",
      machines_selling: "Geräteerlös",
      materials: "Materialkosten",
      materials_selling: "Materialerlös",
      position: "Position",
      machine: "Gerät",
      material: "Material",
      count: "Anzahl",
      hours: "Stunden",
      days: "Tage",
      usage: "Einsatz",
      billed: "Abgerechnet",
      rate: "Stundensatz",
      unit_price: "Einzelpreis",
      amount: "Menge",
      cost: "Kosten",
      subtotal: "Zwischensumme",
      total: "Gesamtkosten",
      selling_price: "Verkaufspreis",
      selling_rate: "Verkaufssatz",
      revenue: "Erlös",
      selling_total: "Gesamterlös",
      no_data: "Keine Kostendaten vorhanden.",
      overnight: "Über Mitternacht",
      overnight_hint: "Diese Schicht geht über Mitternacht hinaus; ihr Ende liegt am Folgetag.",
      overnight_machine_hint:
        "{count} Gerät(e) mit Tagessatz um einen Einsatztag erweitert, da eine Schicht über Mitternacht geht.",
      overnight_machines_notice:
        "Geräte mit Tagessatz, die in einer Schicht über Mitternacht eingesetzt werden, werden mit einem zusätzlichen Einsatztag abgerechnet.",
      rate_notice:
        "Diese Kostenaufstellung basiert auf den beim Speichern des Berichts festgeschriebenen Einkaufspreisen und den aktuellen Stundensätzen. " +
        "Geräte mit Stundensatz zählen die Arbeitszeit ihrer Schichten (oder die abweichend erfasste Einsatzzeit), " +
        "Geräte mit Tagessatz jeden angefangenen Einsatztag.",
      selling_notice:
        "Diese Aufstellung zeigt die Verkaufspreise (Erlöse) in der Verkaufseinheit des Projekts; ein prozentualer Aufschlag gilt auf den festgeschriebenen Einkaufspreis jeder Buchung. " +
        "Geräte mit Stundensatz zählen die Arbeitszeit ihrer Schichten (oder die abweichend erfasste Einsatzzeit), " +
        'Geräte mit Tagessatz jeden angefangenen Einsatztag. Positionen ohne hinterlegten Verkaufspreis werden mit „—" dargestellt.',
    },
    hourly_wage_report_costs: {
      action: "Kostenaufstellung",
      title: "Kostenaufstellung [[hwr]]",
      title_selling: "Erlösaufstellung [[hwr]]",
      back: "Zurück",
      print: "Drucken",
      open_report: "[[hwr]] öffnen",
      loading: "Lade Kosten…",
      load_error: "Kosten konnten nicht geladen werden.",
      print_error: "PDF konnte nicht erstellt werden.",
      attached_note:
        "[[hwr:Dieser/Diese/Dieses]] [[hwr]] ist [[cr:zum/zur/zum]] [[cr]] angehängt: [[hwr:Seine/Ihre/Seine]] Kosten sind dort enthalten und zählen in der Nachkalkulation nicht separat.",
      not_in_post_calculation: "Zählt nicht in der Nachkalkulation",
      contained_chip: "[[cr:Im/In der/Im]] [[cr]] {number}",
      contained_chip_unnumbered: "[[cr:Im/In der/Im]] [[cr]] enthalten",
      open_construction_report: "[[cr:Zum/Zur/Zum]] [[cr]]",
      report_number: "Bericht-Nr.",
      date: "Datum",
      customer: "Auftraggeber",
      project: "Bauvorhaben",
      labor: "Lohnkosten",
      labor_selling: "Lohnerlös",
      incl_employer_contribution: "inkl. Arbeitgeberanteil {amount}",
      machines: "Gerätekosten",
      machines_selling: "Geräteerlös",
      materials: "Materialkosten",
      materials_selling: "Materialerlös",
      efforts: "Zusätzliche Leistungen",
      position: "Position",
      machine: "Gerät",
      material: "Material",
      effort: "Zusätzliche Leistung",
      count: "Anzahl",
      hours: "Stunden",
      duration: "Einsatz",
      billed: "Abgerechnet",
      rate: "Stundensatz",
      unit_price: "Einzelpreis",
      amount: "Menge",
      cost: "Kosten",
      total: "Gesamtkosten",
      selling_price: "Verkaufspreis",
      selling_rate: "Verkaufssatz",
      revenue: "Erlös",
      selling_total: "Gesamterlös",
      no_data: "Keine Kostendaten vorhanden.",
      rate_notice:
        "Diese Kostenaufstellung basiert auf den beim Speichern des Berichts festgeschriebenen Einkaufspreisen und den aktuellen Stundensätzen. " +
        "Geräte mit Tagessatz werden je angefangenem Einsatztag abgerechnet.",
      selling_notice:
        "Diese Aufstellung zeigt die Verkaufspreise (Erlöse) in der Verkaufseinheit des Projekts; ein prozentualer Aufschlag gilt auf den festgeschriebenen Einkaufspreis jeder Buchung. " +
        'Positionen ohne hinterlegten Verkaufspreis werden mit „—" dargestellt.',
    },
  },
  component: {
    autocomplete: {
      search_by_name: "Name",
    },
    fetch_project: {
      text: "Projekt Aktualisieren",
    },
    report_panel: {
      resize: "Breite ändern",
      resize_hint: "Ziehen ändert die Breite · Doppelklick: Standardbreite",
      release_to_minimize: "Loslassen zum Minimieren",
      minimize: "Minimieren",
      restore: "Wiederherstellen",
      full: "Volle Breite",
      exit_full: "Volle Breite beenden",
      close: "Abbrechen",
    },
  },
  validation: {
    unique_machine_device_identifier_for_project: "Gerätenummer {value} existiert bereits",
  },
}
